import ApiService from '@api/api.service';

export default new ApiService({ baseUrl: 'https://rickandmortyapi.com/api' });
